import React from "react";
import { IPlatformPurchaseLinkConfig } from "models/IAppConfig";
import SelectionButton from "./SelectionButton";

interface IProps {
    purchaseLinkConfig: IPlatformPurchaseLinkConfig[];
    onPlatformSelect: (platform: IPlatformPurchaseLinkConfig) => void;
}

export default function PlatformSelect(props: IProps) {
    const { purchaseLinkConfig, onPlatformSelect } = props;

    if (purchaseLinkConfig.length === 0) {
        console.log("no platforms");
        return null;
    }

    return (
        <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap" }}>
            {purchaseLinkConfig.map((platform) => {
                if (typeof platform.displayName === "undefined") {
                    console.log("Platform displayName is undefined");
                    return null;
                }
                if (typeof platform.platformCode === "undefined") {
                    console.log("Platform platformCode is undefined");
                    return null;
                }

                const isDisabled =
                    typeof platform.link === "undefined" &&
                    (typeof platform.storeLinks === "undefined" ||
                        platform.storeLinks.length === 0);

                const onClick =
                    typeof platform.link !== "undefined"
                        ? undefined
                        : () => onPlatformSelect(platform);

                return (
                    <div style={{ margin: 5 }}>
                        <SelectionButton
                            onClick={onClick}
                            href={platform.link}
                            gtmSelector={`${platform.platformCode}_Platform_Selection`}
                            key={platform.platformCode}
                            disabled={isDisabled}
                        >
                            {platform.displayName}
                        </SelectionButton>
                    </div>
                );
            })}
        </div>
    );
}
